// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flashMessage___wrapper___1Glsj"};